import { config } from "./domain_config";

export const isMobioPlus = config.subDomain === "plus";
export const getDomainName = () => {
  return isMobioPlus ? "MobioPlus" : "MobioAstro";
};



// WEBPACK FOOTER //
// ./src/utils/isMobio+.js